import React from 'react'

function DocsIcon(props) {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
			<g clipPath="url(#clip0_3652_80)">
				<path fillRule="evenodd" clipRule="evenodd" d="M14 2L2 2.00004V14H6V15H2C1.44772 15 1 14.5523 1 14V2.00004C1 1.44776 1.44771 1.00004 2 1.00004L14 1C14.5523 0.999998 15 1.44771 15 2V9H14V2ZM11 16C7.875 16 6 12.5 6 12.5C6 12.5 7.5625 9 11 9C14.4375 9 16 12.5 16 12.5C16 12.5 14.125 16 11 16ZM7.94047 11.4339C7.59128 11.8064 7.33019 12.182 7.15622 12.4663L7.16698 12.482C7.36759 12.7751 7.66306 13.1639 8.04157 13.5493C8.81714 14.339 9.82494 15 11 15C12.1751 15 13.1829 14.339 13.9584 13.5493C14.3369 13.1639 14.6324 12.7751 14.833 12.482L14.8438 12.4663C14.6698 12.182 14.4087 11.8064 14.0595 11.4339C13.3515 10.6787 12.3472 10 11 10C9.65281 10 8.64852 10.6787 7.94047 11.4339ZM12.5 12.5C12.5 13.3284 11.8284 14 11 14C10.1716 14 9.5 13.3284 9.5 12.5C9.5 11.6716 10.1716 11 11 11C11.8284 11 12.5 11.6716 12.5 12.5ZM3 4H6V3H3V4ZM6 7H3V6H6V7ZM3 10H6V9H3V10ZM13 4H8V3H13V4ZM8 7H13V6H8V7Z" fill="#3f3f46" />
			</g>
			<defs>
				<clipPath id="clip0_3652_80">
					<rect width="16" height="16" fill="white"/>
				</clipPath>
			</defs>
		</svg>
	)
}

export default DocsIcon
